import { render, staticRenderFns } from "./LayoutSelect.vue?vue&type=template&id=b84d001e&"
import script from "./LayoutSelect.vue?vue&type=script&lang=ts&"
export * from "./LayoutSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports